const routes = [
  {
    index: true,
    label: 'George Vytka',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },

  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
